import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Icon, Message } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import Style from './discountTable.module.css';

export default function DiscountTable({ discounts, discounts_list, onPaste, handleChangeDiscount, readOnly, discountErrors = {}, discountId }) {
    const { t } = useTranslation();

    return (
        <>
            {discounts.length === 100 && <Message title={t('ticket.discountForm.table.limit_exceeded')} type="default" visible />}
            <Table className={`${Style['manual-table']} ${readOnly && Style['read-only']}`} style={{ background: 'red' }}>
                <Table.Header>
                    <Table.Header.Row>
                        <Table.Header.Cell />
                        <Table.Header.Cell className={`${Style['thead']}`}>{t('ticket.discountForm.table.code')}</Table.Header.Cell>
                        <Table.Header.Cell className={`${Style['thead']}`}>
                            {t('ticket.discountForm.table.quota')} <span className={`${Style['optional']}`}>{t('ticket.common.labelOptional')}</span>
                        </Table.Header.Cell>
                        <Table.Header.Cell className={`${Style['thead']}`}>
                            {t('ticket.discountForm.table.name')} <span className={`${Style['optional']}`}>{t('ticket.common.labelOptional')}</span>
                        </Table.Header.Cell>
                    </Table.Header.Row>
                </Table.Header>
                <Table.Body>
                    {discounts_list.map((discount, index) => (
                        <Table.Row key={index} name="discounts">
                            <Table.Cell content={index + 1} />
                            <Table.Cell
                                content={
                                    readOnly || discountId ? (
                                        <span>{discount.code}</span>
                                    ) : (
                                        <div style={{ display: 'flex' }}>
                                            <input onPaste={onPaste} type="text" name="code" value={discount.code} data-id={index} onChange={handleChangeDiscount} />
                                            {discounts[index + 1] &&
                                                Object.values(discounts[index + 1]).find(discount => discount) &&
                                                discountErrors.discounts &&
                                                !!discountErrors.discounts.includes(index) && <Icon name="message-error" color="target" size="regular" />}
                                        </div>
                                    )
                                }
                            />
                            <Table.Cell
                                content={
                                    readOnly ? (
                                        <span>{discount.quota}</span>
                                    ) : (
                                        <input onPaste={onPaste} type="number" name="quota" value={discount.quota} data-id={index} onChange={handleChangeDiscount} />
                                    )
                                }
                            />
                            <Table.Cell
                                content={
                                    readOnly ? (
                                        <span>{discount.name}</span>
                                    ) : (
                                        <input onPaste={onPaste} type="text" name="name" value={discount.name} data-id={index} onChange={handleChangeDiscount} />
                                    )
                                }
                            />
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </>
    );
}

DiscountTable.propTypes = {
    discounts_list: PropTypes.array.isRequired,
    discounts: PropTypes.array.isRequired,
    discountId: PropTypes.number
};
